import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const { t } = useTranslation();

  return (
    <div className="status-bar">
      <div className="container-fluid">
        <div className="d-flex flex-column align-items-center p-2">
          <Link to="/editor" className="btn btn-link light">
            <i className="bi bi-arrow-left" />{" "}
            {t("backToEditorText")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
